import React, { Component } from 'react'

import styles from './style.css'

export default class AspectRatio extends Component {
    render() {
        var style = {
            ...this.props.style,
            backgroundImage: `url(${this.props.image || ''})`
        }
        return (
            <div className={styles.scope}>
                <div className={`${styles.content} ${styles[`ratio${this.props.ratio || '1x1'}`]} ${styles[`${this.props.position || 'cente'}`]}`} style={style} />
                <div className={styles.container}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms/AspectRatio/index.js